import { ca } from '@cian/analytics';

/**
 * @description Событие: блок ипотечного калькулятора попал в зону видимости.
 */
export function trackShowMortgageCalculatorSection(): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'mortgage_calculator',
    name: 'oldevent',
    useLastProducts: true,
  });
}
